import { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Spin, Timeline, Typography } from 'antd'
import { StatusBadge } from '@/Ship/Components/UI/StatusBadge/StatusBadge'
import { ASSIGNMENT_STATUS_MAP, type AssignmentStatus } from '../../Contracts/AssignmentStatus'
import { StatusHistorySectionStore } from '../../Stores/StatusHistorySectionStore'

const { Text } = Typography

interface StatusHistorySectionProps {
    assignmentUuid: string
}

export const StatusHistorySection = observer(({ assignmentUuid }: StatusHistorySectionProps) => {
    const [store] = useState(() => new StatusHistorySectionStore())

    useEffect(() => {
        store.load(assignmentUuid)
    }, [assignmentUuid])

    if (store.loading) return <Spin style={{ display: 'block', margin: '20px auto' }} />
    if (!store.history.length) return <Text type="secondary">Історія порожня</Text>

    return (
        <Timeline
            items={store.history.map((item: any, i: number) => {
                const info = ASSIGNMENT_STATUS_MAP[item.status as AssignmentStatus] || {
                    label: item.status,
                    color: '#8c8c8c',
                }
                const at = item.occurredAt ? new Date(item.occurredAt).toLocaleString('uk-UA') : ''
                const by = item.changedBy?.fullName || item.changedBy?.shortName || '—'
                // Статус змінено в PWA без зв'язку й синхронізовано пізніше
                const offlineAt = item.offlineAt ? new Date(item.offlineAt).toLocaleString('uk-UA') : null
                // Аудит: з якого статусу перейшли і коли водій підтвердив дію у вікні підтвердження
                const previous = item.previousStatus
                    ? ASSIGNMENT_STATUS_MAP[item.previousStatus as AssignmentStatus]?.label || item.previousStatus
                    : null
                const confirmedAt = item.confirmedAt ? new Date(item.confirmedAt).toLocaleString('uk-UA') : null
                return {
                    key: i,
                    color: info.color,
                    children: (
                        <div>
                            <StatusBadge option={{ value: item.status, label: info.label, color: info.color }} />
                            <Text type="secondary" style={{ fontSize: 12, marginLeft: 6 }}>
                                {at}
                            </Text>
                            {previous && (
                                <div style={{ marginTop: 2 }}>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        З: {previous}
                                    </Text>
                                </div>
                            )}
                            <div style={{ marginTop: 2 }}>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Змінив(ла): {by}
                                </Text>
                            </div>
                            {confirmedAt && (
                                <div style={{ marginTop: 2 }}>
                                    <Text type="success" style={{ fontSize: 12 }}>
                                        Дію підтверджено {confirmedAt}
                                    </Text>
                                </div>
                            )}
                            {offlineAt && (
                                <div style={{ marginTop: 2 }}>
                                    <Text type="warning" style={{ fontSize: 12 }}>
                                        Офлайн: виконано {offlineAt}, синхронізовано пізніше
                                    </Text>
                                </div>
                            )}
                        </div>
                    ),
                }
            })}
        />
    )
})
